<template>
  <div class="pa-5 w-full">
    <v-alert v-if="loading" color="primary">
      <v-progress-circular indeterminate></v-progress-circular> Rezept wird gecrawled...</v-alert
    >
    <div class="flex w-full justify-center">
      <h1>HOME</h1>

      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Rezept-Url"
            persistent-placeholder
            placeholder="Welche Rezepteseite soll gecrawled werden?"
            hide-details
            v-model="url"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-btn color="primary" @click="crawlRecipe">Rezept crawlen</v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script src="./Home.js"></script>
